<p-confirmDialog key="confirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="result" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--School Selector-->
<div class="MainMenu">
	<h4 class="CenterText">Student Options</h4>

	<div class="StudentOptionGrid">
		<label>School:</label>
		<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading() == true"> </caass-schoolselector>

		<label>Grade Level:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGradeLevel"
			[(ngModel)]="GradeLevel"
			optionLabel="GradeLevelDesc"
			[filter]="true"
			filterBy="GradeLevelDesc"
			[showClear]="false"
			placeholder="Select a Grade Level"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="GradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevel.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GradeLevelItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevelItem.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Homeroom:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstHomeroom"
			[(ngModel)]="Homeroom"
			optionLabel="HomeRoom"
			[filter]="true"
			filterBy="HomeRoom"
			[showClear]="false"
			placeholder="Select a Homeroom"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Homeroom">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Homeroom.HomeRoom }}
					</div>
				</div>
			</ng-template>
			<ng-template let-HomeroomItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ HomeroomItem.HomeRoom }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Academy:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstAcademy"
			[(ngModel)]="Academy"
			optionLabel="AcademyDesc"
			[filter]="true"
			filterBy="AcademyDesc"
			[showClear]="false"
			placeholder="Select an Academy"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Academy">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Academy.AcademyDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-AcademyItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ AcademyItem.AcademyDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Group:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGroup"
			[(ngModel)]="Group"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupName"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Group">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Group.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Active:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstActiveOption"
			[(ngModel)]="ActiveOption"
			optionLabel="Desc"
			[filter]="true"
			filterBy="Desc"
			[showClear]="false"
			placeholder="Select Active Option"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="ActiveOption">
					<div class="form-control NoBorder" style="text-align: left">
						{{ ActiveOption.Desc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-ActiveOptionItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ ActiveOptionItem.Desc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>
	</div>
</div>

<!--Top Menu-->
<div class="MainMenu TopMargin">
	<h4 class="CenterText">Zero Out Fines/Meals</h4>

	<div class="SectionGrid">
		<!--Account Options-->
		<label style="margin: 0px">Choose Account(s):</label>

		<div class="CheckBoxGrid">
			<input [disabled]="IsLoading() == true" id="ZeroFines" [(ngModel)]="ZeroFines" class="CHKStyle" type="checkbox" />
			<label for="ZeroFines" style="margin: 0px">Fines</label>

			<input [disabled]="IsLoading() == true" id="ZeroMeals" [(ngModel)]="ZeroMeals" class="CHKStyle" type="checkbox" />
			<label for="ZeroMeals" style="margin: 0px">Meals</label>
		</div>

		<!--Adjustment Types-->
		<label style="margin: 0px">Adjustment Type(s):</label>

		<div class="CheckBoxGrid">
			<input [disabled]="IsLoading() == true" id="AdjustStudent" [(ngModel)]="AdjustStudent" class="CHKStyle" type="checkbox" />
			<label for="AdjustStudent" style="margin: 0px">What Student Owes (Debit Account)</label>

			<input [disabled]="IsLoading() == true" id="AdjustSchool" [(ngModel)]="AdjustSchool" class="CHKStyle" type="checkbox" />
			<label for="AdjustSchool" style="margin: 0px">What School Owes (Credit Account)</label>
		</div>

		<label style="margin: 0px">Range:</label>

		<div class="CheckBoxGrid">
			<input class="RadioBtn" type="radio" [(ngModel)]="FMRangeOption" name="FMRangeOption" id="FMAll" value="All" />
			<label for="FMAll">All</label>

			<input class="RadioBtn" type="radio" [(ngModel)]="FMRangeOption" name="FMRangeOption" id="FMDate" value="Date" />
			<label for="FMDate">Date Range</label>
		</div>

		<label *ngIf="FMRangeOption == 'Date'" style="margin: 0px">Date Range:</label>
		<div *ngIf="FMRangeOption == 'Date'" class="DateGrid">
			<p-calendar [disabled]="IsLoading() == true" [(ngModel)]="FMStartDate" showIcon="true" showButtonBar="true"></p-calendar>
			<label style="margin: 0px">to</label>
			<p-calendar [disabled]="IsLoading() == true" [(ngModel)]="FMEndDate" showIcon="true" showButtonBar="true"></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onProcessFinesMeals()">Process</button>

		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onPrintFinesMeals()">Print</button>
	</div>
</div>

<!--Merit Menu-->
<div class="MainMenu TopMargin" *ngIf="MeritAllowed == true">
	<h4 class="CenterText">Zero Out Merits/Demerits</h4>

	<div class="SectionGrid">
		<label style="margin: 0px">Range:</label>
		<div class="CheckBoxGrid">
			<input class="RadioBtn" type="radio" [(ngModel)]="MeritRangeOption" name="MeritRangeOption" id="MeritAll" value="All" />
			<label for="MeritAll">All</label>

			<input class="RadioBtn" type="radio" [(ngModel)]="MeritRangeOption" name="MeritRangeOption" id="MeritDate" value="Date" />
			<label for="MeritDate">Date Range</label>
		</div>

		<label *ngIf="MeritRangeOption == 'Date'" style="margin: 0px">Date Range:</label>
		<div *ngIf="MeritRangeOption == 'Date'" class="DateGrid">
			<p-calendar [disabled]="IsLoading() == true" [(ngModel)]="MeritStartDate" showIcon="true" showButtonBar="true"></p-calendar>
			<label style="margin: 0px">to</label>
			<p-calendar [disabled]="IsLoading() == true" [(ngModel)]="MeritEndDate" showIcon="true" showButtonBar="true"></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onProcessMeritsDemerits()">Process</button>
	</div>
</div>

<!--PBIS Menu-->
<div class="MainMenu TopMargin" *ngIf="PBISAllowed == true">
	<h4 class="CenterText">Zero Out PBIS</h4>

	<div class="SectionGrid">
		<label style="margin: 0px">Range:</label>
		<div class="CheckBoxGrid">
			<input class="RadioBtn" type="radio" [(ngModel)]="PBISRangeOption" name="PBISRangeOption" id="PBISAll" value="All" />
			<label for="PBISAll">All</label>

			<input class="RadioBtn" type="radio" [(ngModel)]="PBISRangeOption" name="PBISRangeOption" id="PBISDate" value="Date" />
			<label for="PBISDate">Date Range</label>
		</div>

		<label *ngIf="PBISRangeOption == 'Date'" style="margin: 0px">Date Range:</label>
		<div *ngIf="PBISRangeOption == 'Date'" class="DateGrid">
			<p-calendar [disabled]="IsLoading() == true" [(ngModel)]="PBISStartDate" showIcon="true" showButtonBar="true"></p-calendar>
			<label style="margin: 0px">to</label>
			<p-calendar [disabled]="IsLoading() == true" [(ngModel)]="PBISEndDate" showIcon="true" showButtonBar="true"></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onProcessPBIS()">Process</button>
	</div>
</div>

<!--Error Message-->
<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<div class="form-group TopMargin">
	<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing (NOTE: It may take a while to update the database).Please wait...</div>
</div>
